export const ARROW_SIZES = {
    big: 'big',
    small: 'small',
    tiny: 'tiny',
}

export const ARROW_TYPES = {
    left: 'left',
    right: 'right',
}



// WEBPACK FOOTER //
// ./components/NavigationArrow/constants.jsx